export default "__VITE_PUBLIC_ASSET__77d6f083__"